import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { userApi } from '@/api/userApi'

export const useUsers = () => {
  return useQuery({
    queryKey: ['users'],
    queryFn: userApi.getUsers,
  })
}

export const useUser = (id) => {
  return useQuery({
    queryKey: ['users', id],
    queryFn: () => userApi.getUserById(id),
    enabled: !!id,
  })
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: userApi.createUser,
    onSuccess: (newUser) => {
      queryClient.setQueryData(['users'], (oldData) => 
        oldData ? [...oldData, newUser] : [newUser]
      )
      queryClient.invalidateQueries(['users'])
    },
  })
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, data }) => userApi.updateUser(id, data),
    onSuccess: (updatedUser) => {
      queryClient.setQueryData(['users'], (oldData) => 
        oldData ? oldData.map(user => 
          user.id === updatedUser.id ? updatedUser : user
        ) : []
      )
      queryClient.setQueryData(['users', updatedUser.id], updatedUser)
      queryClient.invalidateQueries(['users'])
    },
  })
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: userApi.deleteUser,
    onSuccess: (_, deletedId) => {
      queryClient.setQueryData(['users'], (oldData) => 
        oldData ? oldData.filter(user => user.id !== deletedId) : []
      )
      queryClient.removeQueries(['users', deletedId])
      queryClient.invalidateQueries(['users'])
    },
  })
}

export const useBulkUpdateUsers = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: userApi.bulkUpdateUsers,
    onSuccess: () => {
      queryClient.invalidateQueries(['users'])
    },
  })
}